const COUNTRIES = {
  AE: {
    name: {
      en: 'United Arab Emirates',
      ar: 'الإمارات العربية المتحدة',
      zh: '阿拉伯联合酋长国',
    },
    postalCode: {
      format: '00000',
    },
    currency: {
      values: {
        air: 1100,
        touring: 3800,
        grand_touring: 3800,
      },
      iso: 'aed',
      symbol: '',
      abbreviation: 'درهم إماراتي',
    },
    phoneNumber: {
      code: 971,
    },
    measurementSystem: 'metric',
  },
  AR: {
    name: {
      en: 'Argentina',
      ar: 'الأرجنتين',
      zh: '阿根廷',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  AT: {
    name: {
      en: 'Austria',
      ar: 'النمسا',
      zh: '奥地利',
    },
    postalCode: {
      format: 'NNNN',
    },
    currency: {
      values: {
        air: 300,
        touring: 900,
        grand_touring: 900,
      },
      iso: 'eur',
      symbol: '€',
      abbreviation: 'eur',
    },
    phoneNumber: {
      code: 43,
    },
    measurementSystem: 'metric',
  },
  AU: {
    name: {
      en: 'Australia',
      ar: 'أستراليا',
      zh: '澳大利亚',
    },
    currency: {
      values: {
        air: 400,
        touring: 1400,
        grand_touring: 1400,
      },
      iso: 'aud',
      symbol: '$',
      abbreviation: 'aud',
    },
    phoneNumber: {
      code: 61,
    },
    postalCode: {
      format: 'NNNN',
    },
    measurementSystem: 'metric',
  },
  BE: {
    name: {
      en: 'Belgium',
      ar: 'بلجيكا',
      zh: '比利时',
    },
    postalCode: {
      format: 'NNNN',
    },
    currency: {
      values: {
        air: 300,
        touring: 900,
        grand_touring: 900,
      },
      iso: 'eur',
      symbol: '€',
      abbreviation: 'eur',
    },
    phoneNumber: {
      code: 32,
    },
    measurementSystem: 'metric',
  },
  BR: {
    name: {
      en: 'Brazil',
      ar: 'البرازيل',
      zh: '巴西',
    },
    postalCode: {
      format: 'NNNNNNNN',
    },
    measurementSystem: 'metric',
  },
  CA: {
    name: {
      en: 'Canada',
      ar: 'كندا',
      zh: '加拿大',
    },
    postalCode: {
      format: 'ANA NAN',
    },
    currency: {
      values: {
        air: 400,
        touring: 1300,
        grand_touring: 1300,
        dream_edition: 9800,
      },
      total: {
        air: 105000,
        touring: 129000,
        grand_touring: 189000,
        dream_edition: 229000,
      },
      iso: 'cad',
      symbol: '$',
      abbreviation: 'cad',
    },
    phoneNumber: {
      code: 1,
    },
    measurementSystem: 'metric',
  },
  CH: {
    name: {
      en: 'Switzerland',
      ar: 'سويسرا',
      zh: '瑞士',
    },
    postalCode: {
      format: 'NNNN',
    },
    currency: {
      values: {
        air: 300,
        touring: 970,
        grand_touring: 970,
      },
      iso: 'chf',
      symbol: '',
      abbreviation: 'chf',
    },
    phoneNumber: {
      code: 41,
    },
    measurementSystem: 'metric',
  },
  CL: {
    name: {
      en: 'Chile',
      ar: 'تشيلي',
      zh: '智利',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  CN: {
    name: {
      en: 'China',
      ar: 'الصين',
      zh: '中国',
    },
    currency: {
      values: {
        air: 300,
        touring: 1000,
        grand_touring: 1000,
      },
      iso: 'usd',
      symbol: '$',
      abbreviation: 'usd',
    },
    phoneNumber: {
      code: 86,
    },
    postalCode: {
      format: 'NNNNNN',
    },
    measurementSystem: 'metric',
  },
  CY: {
    name: {
      en: 'Cyprus',
      ar: 'قبرص',
      zh: '塞浦路斯',
    },
    postalCode: {
      format: 'NNNN',
    },
    measurementSystem: 'metric',
  },
  CZ: {
    name: {
      en: 'Czech Republic',
      ar: 'جمهورية التشيك',
      zh: '捷克共和国',
    },
    postalCode: {
      format: 'NNN NN',
    },
    measurementSystem: 'metric',
  },
  DE: {
    name: {
      en: 'Germany',
      ar: 'ألمانيا',
      zh: '德国',
    },
    postalCode: {
      format: 'NNNNN',
    },
    currency: {
      values: {
        air: 300,
        touring: 900,
        grand_touring: 900,
      },
      iso: 'eur',
      symbol: '€',
      abbreviation: 'eur',
    },
    phoneNumber: {
      code: 49,
    },
    measurementSystem: 'metric',
  },
  DK: {
    name: {
      en: 'Denmark',
      ar: 'الدانمارك',
      zh: '丹麦',
    },
    postalCode: {
      format: 'NNNN',
    },
    currency: {
      values: {
        air: 2000,
        touring: 6700,
        grand_touring: 6700,
      },
      iso: 'dkk',
      symbol: '',
      abbreviation: 'dkk',
    },
    phoneNumber: {
      code: 45,
    },
    measurementSystem: 'metric',
  },
  EC: {
    name: {
      en: 'Ecuador',
      ar: 'الإكوادور',
      zh: '厄瓜多尔',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  EE: {
    name: {
      en: 'Estonia',
      ar: 'إستونيا',
      zh: '爱沙尼亚',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  EG: {
    name: {
      en: 'Egypt',
      ar: 'مصر',
      zh: '埃及',
    },
    postalCode: {
      format: '00000',
    },
    measurementSystem: 'metric',
  },
  ES: {
    name: {
      en: 'Spain',
      ar: 'إسبانيا',
      zh: '西班牙',
    },
    postalCode: {
      format: 'NNNNN',
    },
    currency: {
      values: {
        air: 300,
        touring: 900,
        grand_touring: 900,
      },
      iso: 'eur',
      symbol: '€',
      abbreviation: 'eur',
    },
    phoneNumber: {
      code: 34,
    },
    measurementSystem: 'metric',
  },
  FI: {
    name: {
      en: 'Finland',
      ar: 'فنلندا',
      zh: '芬兰',
    },
    postalCode: {
      format: 'NNNNN',
    },
    currency: {
      values: {
        air: 300,
        touring: 900,
        grand_touring: 900,
      },
      iso: 'eur',
      symbol: '€',
      abbreviation: 'eur',
    },
    phoneNumber: {
      code: 358,
    },
    measurementSystem: 'metric',
  },
  FR: {
    name: {
      en: 'France',
      ar: 'فرنسا',
      zh: '法国',
    },
    postalCode: {
      format: 'NNNNN',
    },
    currency: {
      values: {
        air: 300,
        touring: 900,
        grand_touring: 900,
      },
      iso: 'eur',
      symbol: '€',
      abbreviation: 'eur',
    },
    phoneNumber: {
      code: 33,
    },
    measurementSystem: 'metric',
  },
  GB: {
    name: {
      en: 'United Kingdom',
      ar: 'المملكة المتحدة',
      zh: '英国',
    },
    postalCode: {
      format: '*******',
    },
    currency: {
      values: {
        air: 200,
        touring: 770,
        grand_touring: 770,
      },
      iso: 'gbp',
      symbol: '£',
      abbreviation: 'gbp',
    },
    phoneNumber: {
      code: 44,
    },
    measurementSystem: 'imperial',
  },
  GE: {
    name: {
      en: 'Georgia',
      ar: 'جورجيا',
      zh: '格鲁吉亚',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  GL: {
    name: {
      en: 'Greenland',
      ar: 'جرين لاند',
      zh: '格陵兰',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  GR: {
    name: {
      en: 'Greece',
      ar: 'اليونان',
      zh: '希腊',
    },
    postalCode: {
      format: 'NNNNN',
    },
    measurementSystem: 'metric',
  },
  HK: {
    name: {
      en: 'Hong Kong',
      ar: 'هونج كونج',
      zh: '香港',
    },
    currency: {
      values: {
        air: 2300,
        touring: 7800,
        grand_touring: 7800,
      },
      iso: 'hkd',
      symbol: 'HK$',
      abbreviation: 'hkd',
    },
    phoneNumber: {
      code: 852,
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  HR: {
    name: {
      en: 'Croatia',
      ar: 'كرواتيا',
      zh: '克罗地亚',
    },
    postalCode: {
      format: 'NNNNN',
    },
    measurementSystem: 'metric',
  },
  HU: {
    name: {
      en: 'Hungary',
      ar: 'المجر',
      zh: '匈牙利',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  ID: {
    name: {
      en: 'Indonesia',
      ar: 'إندونيسيا',
      zh: '印度尼西亚',
    },
    postalCode: {
      format: 'NNNNN',
    },
    measurementSystem: 'metric',
  },
  IE: {
    name: {
      en: 'Ireland',
      ar: 'أيرلندا',
      zh: '爱尔兰',
    },
    postalCode: {
      format: '[D6W/ANN] [A/N][A/N][A/N][A/N]',
    },
    measurementSystem: 'metric',
  },
  IL: {
    name: {
      en: 'Israel',
      ar: 'إسرائيل',
      zh: '以色列',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  IN: {
    name: {
      en: 'India',
      ar: 'الهند',
      zh: '印度',
    },
    postalCode: {
      format: 'NNNNNN',
    },
    measurementSystem: 'metric',
  },
  IS: {
    name: {
      en: 'Iceland',
      ar: 'أيسلاندا',
      zh: '冰岛',
    },
    postalCode: {
      format: 'NNN',
    },
    currency: {
      values: {
        air: 36800,
        touring: 122800,
        grand_touring: 122800,
      },
      iso: 'isk',
      symbol: '',
      abbreviation: 'isk',
    },
    phoneNumber: {
      code: 354,
    },
    measurementSystem: 'metric',
  },
  IT: {
    name: {
      en: 'Italy',
      ar: 'إيطاليا',
      zh: '意大利',
    },
    postalCode: {
      format: 'NNNNN',
    },
    currency: {
      values: {
        air: 300,
        touring: 900,
        grand_touring: 900,
      },
      iso: 'eur',
      symbol: '€',
      abbreviation: 'eur',
    },
    phoneNumber: {
      code: 39,
    },
    measurementSystem: 'metric',
  },
  JP: {
    name: {
      en: 'Japan',
      ar: 'اليابان',
      zh: '日本',
    },
    currency: {
      values: {
        air: 31000,
        touring: 105000,
        grand_touring: 105000,
      },
      iso: 'jpy',
      symbol: '¥',
      abbreviation: 'jpy',
    },
    phoneNumber: {
      code: 81,
    },
    postalCode: {
      format: 'NNNNNNN',
    },
    measurementSystem: 'metric',
  },
  KR: {
    name: {
      en: 'South Korea',
      ar: 'كوريا الجنوبية',
      zh: '韩国',
    },
    currency: {
      values: {
        air: 339000,
        touring: 1130000,
        grand_touring: 1130000,
      },
      iso: 'krw',
      symbol: '₩',
      abbreviation: 'krw',
    },
    phoneNumber: {
      code: 82,
    },
    postalCode: {
      format: 'NNNNN',
    },
    measurementSystem: 'metric',
  },
  KZ: {
    name: {
      en: 'Kazakhstan',
      ar: 'كازخستان',
      zh: '哈萨克斯坦',
    },
    postalCode: {
      format: '',
    },
  },
  LI: {
    name: {
      en: 'Liechtenstein',
      ar: 'ليسشنستاين',
      zh: '列支敦士登',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  LT: {
    name: {
      en: 'Lithuania',
      ar: 'ليتوانيا',
      zh: '立陶宛',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  LU: {
    name: {
      en: 'Luxembourg',
      ar: 'لوكسمبورج',
      zh: '卢森堡',
    },
    postalCode: {
      format: 'NNNN',
    },
    measurementSystem: 'metric',
  },
  LV: {
    name: {
      en: 'Latvia',
      ar: 'لاتفيا',
      zh: '拉脱维亚',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  MC: {
    name: {
      en: 'Monaco',
      ar: 'موناكو',
      zh: '摩纳哥',
    },
    postalCode: {
      format: 'NNNNN',
    },
    currency: {
      values: {
        air: 300,
        touring: 900,
        grand_touring: 900,
      },
      iso: 'eur',
      symbol: '€',
      abbreviation: 'eur',
    },
    phoneNumber: {
      code: 377,
    },
    measurementSystem: 'metric',
  },
  MO: {
    name: {
      en: 'Macao',
      ar: 'ماكاو',
      zh: '澳门',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  MX: {
    name: {
      en: 'Mexico',
      ar: 'المكسيك',
      zh: '墨西哥',
    },
    postalCode: {
      format: 'NNNNN',
    },
    measurementSystem: 'metric',
  },
  NO: {
    name: {
      en: 'Norway',
      ar: 'النرويج',
      zh: '挪威',
    },
    postalCode: {
      format: 'NNNN',
    },
    currency: {
      values: {
        air: 2700,
        touring: 8900,
        grand_touring: 8900,
      },
      iso: 'nok',
      symbol: '',
      abbreviation: 'nok',
    },
    phoneNumber: {
      code: 47,
    },
    measurementSystem: 'metric',
  },
  NL: {
    name: {
      en: 'Netherlands',
      ar: 'هولندا',
      zh: '荷兰',
    },
    postalCode: {
      format: 'NNNN AA',
    },
    currency: {
      values: {
        air: 300,
        touring: 900,
        grand_touring: 900,
      },
      iso: 'eur',
      symbol: '€',
      abbreviation: 'eur',
    },
    phoneNumber: {
      code: 31,
    },
    measurementSystem: 'metric',
  },
  NZ: {
    name: {
      en: 'New Zealand',
      ar: 'نيوزيلندا',
      zh: '新西兰',
    },
    currency: {
      values: {
        air: 400,
        touring: 1400,
        grand_touring: 1400,
      },
      iso: 'nzd',
      symbol: '$',
      abbreviation: 'nzd',
    },
    phoneNumber: {
      code: 64,
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  PL: {
    name: {
      en: 'Poland',
      ar: 'بولندا',
      zh: '波兰',
    },
    postalCode: {
      format: 'NN-NNN',
    },
    measurementSystem: 'metric',
  },
  PT: {
    name: {
      en: 'Portugal',
      ar: 'البرتغال',
      zh: '葡萄牙',
    },
    postalCode: {
      format: 'NNNN',
    },
    measurementSystem: 'metric',
  },
  PY: {
    name: {
      en: 'Paraguay',
      ar: 'الباراغواي',
      zh: '巴拉圭',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  QA: {
    name: {
      en: 'Qatar',
      ar: 'قطر',
      zh: '卡塔尔',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  RO: {
    name: {
      en: 'Romania',
      ar: 'رومانيا',
      zh: '罗马尼亚',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  RU: {
    name: {
      en: 'Russia',
      ar: 'روسيا',
      zh: '俄国',
    },
    postalCode: {
      format: 'NNNNNN',
    },
    measurementSystem: 'metric',
  },
  SA: {
    name: {
      en: 'Saudi Arabia',
      ar: 'السعودية',
      zh: '沙特阿拉伯',
    },
    postalCode: {
      format: 'NNNNN',
    },
    currency: {
      values: {
        air: 1100,
        touring: 3800,
        grand_touring: 3800,
      },
      iso: 'sar',
      symbol: '',
      abbreviation: 'ر.س',
    },
    phoneNumber: {
      code: 966,
    },
    measurementSystem: 'metric',
  },
  SE: {
    name: {
      en: 'Sweden',
      ar: 'السويد',
      zh: '瑞典',
    },
    postalCode: {
      format: 'NNNNN',
    },
    currency: {
      values: {
        air: 2800,
        touring: 9450,
        grand_touring: 9450,
      },
      iso: 'sek',
      symbol: '',
      abbreviation: 'sek',
    },
    phoneNumber: {
      code: 46,
    },
    measurementSystem: 'metric',
  },
  SG: {
    name: {
      en: 'Singapore',
      ar: 'سنغافورة',
      zh: '新加坡',
    },
    postalCode: {
      format: 'NNNNNN',
    },
    measurementSystem: 'metric',
  },
  TR: {
    name: {
      en: 'Turkey',
      ar: 'تركيا',
      zh: '火鸡',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  TW: {
    name: {
      en: 'Taiwan',
      ar: 'تايوان',
      zh: '台湾',
    },
    currency: {
      values: {
        air: 8600,
        touring: 28700,
        grand_touring: 28700,
      },
      iso: 'twd',
      symbol: 'NT$',
      abbreviation: 'twd',
    },
    phoneNumber: {
      code: 886,
    },
    postalCode: {
      format: 'NNNNN',
    },
    measurementSystem: 'metric',
  },
  UA: {
    name: {
      en: 'Ukraine',
      ar: 'أوكرانيا',
      zh: '乌克兰',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
  US: {
    name: {
      en: 'United States',
      ar: 'الولايات المتحدة',
      zh: '美国',
    },
    postalCode: {
      format: 'NNNNN',
    },
    currency: {
      values: {
        air: 300,
        touring: 1000,
        grand_touring: 1000,
        dream_edition: 7500,
      },
      total: {
        air: 77400,
        touring: 95000,
        grand_touring: 139000,
        dream_edition: 169000,
      },
      iso: 'usd',
      symbol: '$',
      abbreviation: 'usd',
    },
    phoneNumber: {
      code: 1,
    },
    measurementSystem: 'imperial',
  },
  UY: {
    name: {
      en: 'Uruguay',
      ar: 'الأورغواي',
      zh: '乌拉圭',
    },
    postalCode: {
      format: '',
    },
    measurementSystem: 'metric',
  },
};

export default COUNTRIES;
